import * as React from 'react';

import { enumUnit, Unit } from '@rematter/frontend-lib-api-client';
import { enumLoadWeightType } from '@rematter/modules/trade/types/load';
import { TouchNumberField } from '@rematter/ui-web';

import { useWeightConversion } from '../../../../hooks/useWeightConversion';
import { LoadStagedFieldProps } from '../_types';

export const NetWeightField: React.FC<LoadStagedFieldProps> = ({
  lineItem,
  weightUnit = 'price',
  facilityDefaultUnit = enumUnit.Pounds,
  touchModeEnabled,
  onUpdateItem,
}) => {
  const { convertToDisplayUnit, convertFromDisplayUnit, massUnitAbbreviation } =
    useWeightConversion({
      weightUnit,
      facilityDefaultUnit,
      pricingUnit: lineItem.pricingUnit as Unit,
    });

  const handleNetWeightChange = React.useCallback(
    (value: number) => {
      const storedUnit =
        (lineItem.weights?.[enumLoadWeightType.Net]?.unit as Unit) ||
        enumUnit.Pounds;
      const convertedValue = convertFromDisplayUnit(value, storedUnit);

      onUpdateItem(lineItem.id, {
        weights: {
          ...lineItem.weights,
          [enumLoadWeightType.Net]: {
            value: convertedValue,
            unit: storedUnit,
            __typename: 'Weight',
          },
        },
      });
    },
    [lineItem.weights, lineItem.id, convertFromDisplayUnit, onUpdateItem],
  );

  const isQuantityBased = lineItem.pricingUnit === enumUnit.Each;

  if (isQuantityBased) {
    return <div />;
  }

  return (
    <TouchNumberField
      aria-label="Net weight"
      touchModeEnabled={touchModeEnabled}
      value={convertToDisplayUnit(lineItem.weights?.[enumLoadWeightType.Net])}
      isDisabled={true}
      formatOptions={{ minimumFractionDigits: 0, maximumFractionDigits: 2 }}
      variant="outlined"
      suffix={massUnitAbbreviation}
      prefix="N"
      onChange={handleNetWeightChange}
      className="@NetWeightField"
    />
  );
};
